/*
 * @Author: Src
 * @Date: 2025-07-24 11:24:41
 * @LastEditTime: 2026-05-07 18:44:03
 * @LastEditors: Src
 * @FilePath: /work-station/src/services/car.service.ts
 * @Description: 头部注释配置模板
 */
import { inject, injectable } from 'inversify';
import HttpClient from './http.service';
import { BASE_CAR_URL } from '@/common/constant';
import { Staff } from '@/common/interface/shop';
import { getAudioListWithDuration } from '../common/utils';


@injectable()
export default class CarService {
  @inject(HttpClient)
  protected http!: HttpClient;

  async getCarCommodityList(params: any, loadingEl?: Element | Vue) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/platform/car_commodity/list`, {
        params,
        data: {
          loadingEl,
        },
      }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  async addCarCommodity(params: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/car_commodity/add`, params) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  async updateCarCommodity(params: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/car_commodity/edit`, params) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  /**
 * 车源详情
 */
  async getCarCommodityDetail(params: any) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/platform/car_commodity/detail`, { params }) as any;
      const data = res;
      data.brand_id = res.brand_id;
      data.series_id = res.series_id;
      data.model_id = res.model_id;
      return data;
    } catch (error) {
      return null;
    }
  }

  /**
 * 车辆上下架
 */
  async getCarCommodityPush(params: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/car_commodity/push`, params) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  /**
* 删除
*/
  async getCarCommodityDelete(params: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/car_commodity/delete`, params) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  async getCarBrandList() {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/car/brand`) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  async getCarCategoryList() {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/car/category`) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  async getCarSeriesList(bid: number) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/car/manufacturer/${bid}`) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  async getCarModelList(bid: number) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/car/series/${bid}`) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  async getCarModelDetail(sid: number) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/car/models/${sid}`) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  async getCarShopList(params: any, loadingEl?: Element | Vue) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/platform/car_shop/list`, {
        params,
        data: {
          loadingEl,
        },
      }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  async getCarInfoEdit(params: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/car_shop/info/edit`, params) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  async getCarShopDetail(carShopCode: string, loadingEl?: Element | Vue) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/platform/car_shop/${carShopCode}/detail`, {
        data: {
          loadingEl,
        },
      }) as any;
      const staffList: {
        [key: string]: {
          roleId: number;
          desc: string;
          data: Staff[];
        };
      } = res.staff;
      const {
        car_shop_code,
        car_shop_id,
        poi,
        name,
        regionpid,
        regionid,
        adcode,
        address,
        start_time,
        area,
        head_pics,
        cover_pics,
        pics,
        join_videos,
        tels,
        manager_id,
        identity_num,
        shop_license,
        boss_id,
        staff_id,
        remark,
        online_status,
        company,
        review_status,
        online_gd_status,
        online_gd_time,
        business_time,
        cp_id,
        offline_gd_time,
        videos,
        map_location,
        merchant_telephone,
        bossPhone,
        latitude,
        longitude,
        encryptedTels,
        encryptedMerchantTelephone,
        encryptedBossPhone,
        shop_user_relations,
        onlinestatus,
        onlinestatus_value,
        merchant_status,
        fail_reason,
        expireTime,
        merchant_shop_id,
        regionName,
        businessLicense,
        idCardInfo,
        other_qualifications,
        mainBusinessAtagName,
        createRightsStatus,
        merchantOrderFailReason,
        is_album,
        sub_name,
        market_name,
        market_id,
        market_err_msg,
        marketAuditStatus,
        merchant_status_value,
      } = res;
      const carShopDetail = {
        carShopCode: car_shop_code,
        carShopId: car_shop_id,
        poi,
        latitude,
        longitude,
        bossPhone,
        name,
        regionpid,
        regionid,
        adcode,
        address,
        startTime: start_time,
        area,
        headPics: head_pics,
        coverPics: cover_pics,
        pics,
        joinVideos: join_videos,
        tels,
        managerId: manager_id,
        identityNum: identity_num,
        shopLicense: shop_license,
        bossId: boss_id,
        staffId: staff_id,
        remark,
        onlineStatus: online_status,
        company,
        reviewStatus: review_status,
        onlineGdStatus: online_gd_status,
        onlineGdTime: online_gd_time,
        businessTime: business_time,
        cpId: cp_id,
        offlineGdTime: offline_gd_time,
        videos,
        mapLocation: map_location,
        merchantTelephone: merchant_telephone,
        encryptedTels,
        encryptedMerchantTelephone,
        encryptedBossPhone,
        shopUserRelations: shop_user_relations,
        onlinestatus,
        onlinestatusValue: onlinestatus_value,
        merchantStatus: merchant_status,
        staff: staffList,
        failReason: fail_reason,
        expireTime,
        merchantShopId: merchant_shop_id,
        detailAddress: `${regionName} ${address}`,
        businessLicense,
        idCardInfo,
        otherQualifications: other_qualifications,
        mainBusinessAtagName,
        createRightsStatus,
        merchantOrderFailReason,
        is_album,
        sub_name,
        market_name,
        market_id,
        marketErrMsg: market_err_msg,
        marketAuditStatus,
        merchantStatusValue: merchant_status_value,
      };
      return carShopDetail;
    } catch (error) {
      return null;
    }
  }

  /**
   * 车源配置
   */
  async getCarConfig() {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/car/config`) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  // 获取订单
  async auditEditShopOrder(params: any, loadingEl?: Element | Vue) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/platform/shop_order/list`, {
        params,
        data: {
          loadingEl,
        },
      }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  /**
   * 获取套餐列表
   * @param
   * @returns
   */
  async shopOrderPackages() {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/platform/shop_order/packages`) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  // 确认收款
  async postShopOrderConfirm(params: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/shop_order/confirm`, params) as any;
      return res;
    } catch (error) {
      return '';
    }
  }


  // 赠送天数
  async postShopOrderDonate(params: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/shop_order/donate`, params) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  // 追加备注
  async postShopOrderAppendRemark(params: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/shop_order/append_remark`, params) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  // 全额退款
  async postShopOrderRefund(params: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/shop_order/refund`, params) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  // 全额退款
  async getBackgroundAudioManager(params: any) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/platform/shop_order/order/amount`, { params }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  // 修改地推员
  async postShopOrderEditStaff(params: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/shop_order/edit_staff`, params) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  // 地推员
  async postShopOrderStaff() {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/platform/shop_order/staff`) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  // 付款方式
  async postShopOrderPayChannel() {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/platform/shop_order/pay_channel`) as any;
      return res;
    } catch (error) {
      return null;
    }
  }
  // 暂停营业
  async postCarShopStopBusiness(shopCode: any, params: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/car_shop/amap/yd/${shopCode}/stop_business`, params) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  // 永久停业
  async postCarShopForeverStopBusiness(shopCode: any, params: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/car_shop/amap/yd/${shopCode}/foreverStopBusiness`, params) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  //  惩罚下线
  async postCarShopPenaltyOffline(shopCode: any, params: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/car_shop/amap/yd/${shopCode}/offlineBusiness`, params) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  /**
   * 门店下线
   * @param shopCode
   * @param params
   * @returns
   */
  async postCarShopOfflineBusiness(shopCode: any, params: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/car_shop/amap/yd/${shopCode}/offline`, params) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  // 恢复营业
  async postCarShopStartBusiness(shopCode: any) {
    try {
      const data = {
        full: true,
      };
      const res = await this.http.post(`${BASE_CAR_URL}/platform/car_shop/amap/yd/${shopCode}/start_business`, data) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  // 推送门店信息至高德云店
  async postCarShopCreateShop(shopCode: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/car_shop/amap/yd/${shopCode}/createShop`) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  // 查询商家平台状态
  async postCarShopQueryStatus(shopCode: any) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/platform/car_shop/amap/yd/query/${shopCode}/status`) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  // 删除关联关系
  async delCarShopDeleteRelation(params: any) {
    try {
      const res = await this.http.delete(`${BASE_CAR_URL}/platform/car_shop/delete/relation`, { params }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  // 添加关联关系
  async addCarShopAddRelation(params: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/car_shop/add/relation`, params) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  // 解密手机号
  async postPhoneDecrypt(params: any) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/tool/phone/decrypt`, { params }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  // 推送门店语音至高德云店
  async shopEcSyncPushVoiceToAMap(data: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/car_shop/sync/pushVoiceToGd`, data) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  // 获取凭证
  async shopShopOrderPayVoucher(params: any) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/platform/shop_order/pay_voucher`, { params }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }
  // 获取凭证
  async shopShopOrderReceiptVoucher(params: any) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/platform/shop_order/voucher/query/receipt-voucher`, { params }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  // 修改凭证
  async postShopOrderVoucher(data: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/shop_order/voucher/edit/receipt-voucher`, data) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  async getShopOrderList(params: any) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/platform/shop_order/voucher/order/list`, { params }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  async deleteShopOrderDeleteReceipt(params: any) {
    try {
      const res = await this.http.delete(`${BASE_CAR_URL}/platform/shop_order/voucher/delete/receipt-voucher`, { params }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  async postCarOrderBindAgent(carShopCode: string, params: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/car_shop/${carShopCode}/bind/agent`, params) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  /**
   * 推广通绑定
   * @param params
   * @returns
   */
  async postCarShopBindAgent(params: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/advertiser/bind/agent`, params) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  /**
   * 查询广告主状态
   * @param params
   * @returns
   */
  async postCarShopAgentBindSearch(params: any) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/platform/advertiser/agent-bind-search`, { params }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  /**
   * 绑定广告主电话
   * @param params
   * @returns
   */
  async postCarShopChangeAdPhone(params: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/advertiser/change/adPhone`, params) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  /**
   * 获取广告主信息
   * @param params shopId 门店id
   * @returns
   */
  async getAdvertiserInfo(params: any) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/platform/advertiser/info`, { params }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  /**
   *
   * @param params
   * @returns
   */
  async postCarShopBindShopRelation(params: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/advertiser/bind/shop/relation`, params) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  // 查询用户信息
  async getCarShopQueryUserInfo(params: any) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/platform/car_shop/query/user/info`, { params }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  // 查询订单自动结算列表
  async getCarOrderSettlementList(params: any, loadingEl?: Element | Vue) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/platform/shop_order/settlement/list`, {
        params,
        data: {
          loadingEl,
        },
      }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  // 订单自动结算重试
  async postCarOrderSettlementRetry(transferNo: string) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/platform/shop_order/settlement/retry/${transferNo}`) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  // 查询订单退款列表
  async getCarOrderRefundList(params: any, loadingEl?: Element | Vue) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/platform/shop_order/refund/list`, {
        params,
        data: {
          loadingEl,
        },
      }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  async postCarShopCancelRightsOrder(params: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/car_shop/cancel/rights_order`, params) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  /**
   * 结算单列表接口
   * @param params
   * @returns
   */
  async getCarOrderSettlementBillList(params: any) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/platform/shop_order/settlement/bill/list`, { params }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  /**
   * 结算单详接口
   * @param billId
   * @returns
   */
  async getCarOrderSettlementBillDetail(billId: string) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/platform/shop_order/settlement/bill/detail/${billId}`) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  /**
   * 结算单转账记录接口
   * @param params
   * @returns
   */
  async getCarOrderSettlementBillTransferRecords(params: any) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/platform/shop_order/settlement/bill/transfer/records`, { params }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  /**
   * 结算单关联的支付订单列表接口
   * @param params
   * @returns
   */
  async getCarOrderSettlementBillOrders(params: any, loadingEl?: Element | Vue) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/platform/shop_order/settlement/bill/orders`, {
        params,
        data: {
          loadingEl,
        },
      }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  /**
   * 二手车相册信息接口
   * @param params
   * @param loadingEl
   * @returns
   */
  async getCarShopAlbumInfo(params: any, loadingEl?: Element | Vue) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/platform/album/info`, {
        params,
        data: {
          loadingEl,
        },
      }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  /**
   * 新增相册图片接口
   * @param params
   * @returns
   */
  async postCarShopAlbumPhotoUpload(params: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/album/photo/upload`, params) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  /**
   * 二手车门脸照
   * @param params
   * @returns
   */
  async postCarShopAlbumEditFace(shopCode: string, params: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/album/edit/${shopCode}/face`, params) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  async getCarShopAlbumOfficialInfo(params: any) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/platform/album/official/info`, { params }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  async getCarMarket(params: any) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/car/market`, { params }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  async postCarShopUpdateMarket(params: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/car_shop/update/market`, params) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  async getCarShopMarketList(params: any, loadingEl?: Element | Vue) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/platform/car_shop/market/list`, {
        params,
        data: {
          loadingEl,
        },
      }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  /**
   * 主图删除接口
   * @param data data.shopId 店铺id data.header [] 图片id
   * @returns
   */
  async deleteCarShopAlbumHeader(data: any) {
    try {
      const res = await this.http.delete(`${BASE_CAR_URL}/platform/album/header/delete`, { data }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  async getCarKaAll() {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/platform/ka/all`) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  /**
   * 获取车型信息
   * @param params
   * @returns
   */
  async getVinModel(params: any) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/car/vin_model`, { params }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  /**
   * 二手车品牌列表
   * @param params
   * @returns
   */
  async getCarKaList(params: any) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/platform/car/ka/list`, { params }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  /**
   * 二手车品牌录音列表
   * @param params
   * @returns
   */
  async getCarKaAudioList(params: any) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/platform/car/ka/audio/list`, { params }) as any;
      const dataSource = await getAudioListWithDuration(res.list, res.total);
      return dataSource;
    } catch (error) {
      return null;
    }
  }


  /**
   * 手动推送录音到高德
   * @param params
   * @returns
   */
  async carKaAudioPush(params: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/car/ka/audio/push`, params) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  /**
   * 预估价查询
   * @param params
   * @returns
   */
  async getCarEval(params: any) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/car/eval`, { params }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  /**
   * 添加店铺市场
   * @param params
   * @returns
   */
  async carShopMarketAdd(params: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/car_shop/market/add`, params) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  /**
   * 编辑市场信息
   * @param params
   * @returns
   */
  async carShopMarketEdit(params: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/car_shop/market/edit`, params) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  /**
   *
   * @param params
   * @returns
   */
  async getCarShopShopReportData(params: any, loadingEl?: Element | Vue) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/platform/car_shop/query/shopReport/data`, {
        params,
        data: {
          loadingEl,
        },
      }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  async getCarShopShopReportDetail(params: any) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/platform/car_shop/query/shopReport/detail`, { params }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  /**
   * 巡店添加巡店记录
   * @param shopCode
   * @param params
   * @returns
   */
  async carShopInspectionAdd(shopCode: string, params: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/car_shop/inspection/${shopCode}/add`, params) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  /**
   * 巡店列表
   * @param shopCode
   * @param params
   * @returns
   */
  async carShopInspectionList(shopCode: string, params: any) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/platform/car_shop/inspection/${shopCode}/list`, { params }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  /**
   * 标题
   * @returns
   */
  async carShopInspectionOption() {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/platform/car_shop/inspection/option`) as Array<{
        name: string;
        value: Array<{ name: string }>;
      }>;
      return res;
    } catch (error) {
      return null;
    }
  }


  /**
   * 店铺工单列表
   * @param shopCode
   * @param params
   * @returns
   */
  async carShopUpdateRecordList(shopCode: string, params: any) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/platform/car_shop/update_record/${shopCode}/list`, { params }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  /**
   * 重新推送店铺工单
   * @param shopCode
   * @param params
   */
  async carShopUpdateRecordDelete(params: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/car_shop/update_record/re_push`, params) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  /**
   * 查询工单状态
   * @param params
   * @returns
   */
  async carShopUpdateRecordQueryWorkOrderStatus(params: any) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/platform/car_shop/update_record/query/workOrder/status`, { params }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  /**
   * 删除工单
   * @param params
   * @returns
   */
  async carShopUpdateRecordDeleteWorkOrder(data: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/car_shop/update_record/delete/workOrder`, data) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  /**
   * 迁址
   * @param data
   * @returns
   */
  async postCarChangePoiRelocate(data: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/car_shop/change/poi/relocate`, data) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  /**
   * 重开
   * @param data
   * @returns
   */
  async postCarChangePoiRecreate(data: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/car_shop/change/poi/recreate`, data) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  /**
   * 更新
   * @param data
   * @returns
   */
  async postCarChangePoiUpdate(data: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/car_shop/change/poi/update`, data) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  /**
   * 同步商家状态
   * @param shopCode
   * @returns
   */
  async getCarShopAmapYdQueryInfo(shopCode: string) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/car_shop/amap/yd/query/${shopCode}/info`) as any;
      return res;
    } catch (error) {
      return null;
    }
  }
}
